import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { usePagination } from '@webapp/core/hooks/usePagination'
import { CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { creditCardItemQueries } from '@webapp/modules/accounts-payable/query-configs/creditCardItemQueries'

interface IUseQueryCreditCardItemsParams {
  accountId: number
  archived: boolean
  onError?: (err: unknown) => void
}

interface IUseQueryCreditCardItemsReturn {
  items: CreditCardItem[]
  isLoading: boolean
  error: unknown
}

export const useQueryCreditCardItems = ({
  accountId,
  archived,
  onError,
}: IUseQueryCreditCardItemsParams): IUseQueryCreditCardItemsReturn => {
  const { params, updateNumPages } = usePagination({
    id: 'ap-reconcile-items',
  })

  const { data, isLoading, error } = useQuery({
    // Always pending_reconcile=True; `archived` follows the FS tab (BHV-010).
    ...creditCardItemQueries.list({
      creditcardId: accountId,
      archived,
      page: params.page,
      pageSize: params.pageSize,
    }),
    onSuccess: (res) => {
      updateNumPages(res.pagination.numPages)
    },
    onError,
  })

  const items = useMemo(
    () =>
      (data?.items ?? []).map((constructor) => new CreditCardItem(constructor)),
    [data]
  )

  return {
    items,
    isLoading,
    error,
  }
}
